import { ICalendarEntry } from './calendarEntry.model';

export interface IAbsence {
  id?: string;
  date?: string;
  calendarEntry?: ICalendarEntry;
  professeur?: string;
}

export const defaultValue: Readonly<IAbsence> = {
  id: null,
  date: '',
  professeur: '',
  calendarEntry: null,
};
